class Quotes {
  constructor(el) {
    this.el = el;
    this.cite = el.querySelector( 'cite' );

    if (!this.cite) {
      return;
    }

    this.check();
    this.events();
  }

  check() {
    this.isLong = this.cite && this.cite.clientHeight > 60;
    if (this.isLong) {
      this.cite.classList.add( 'is-long' );
    } else {
      this.cite.classList.remove( 'is-long' );
    }
  }

  events() {
    window.addEventListener( 'resize', () => this.check() );
    window.addEventListener( 'orientationchange', () => this.check() );
  }
}

Array.from( document.getElementsByClassName( 'vrgz-quote' ) )?.forEach( (el) => new Quotes( el ) );
